<form id="confirmForm">
  <dialog-header>{{ title }}</dialog-header>
  <mat-dialog-content>
    <p class="align-left" [innerHTML]="message"></p>
  </mat-dialog-content>
  <mat-dialog-actions
    align="end"
    class="tw-gap-4"
    [class.has-secondary-action]="!!secondaryButton"
  >
    <button
      id="cancelButton"
      matButton="outlined"
      type="button"
      class="confirm-modal-action"
      [class.confirm-modal-action--full]="!secondaryButton"
      [class.confirm-modal-action--fit]="!!secondaryButton"
      (click)="close()"
    >
      {{ cancelButton }}
    </button>
    @if (secondaryButton) {
      <button
        id="confirm-secondary"
        matButton="outlined"
        type="button"
        class="confirm-modal-action confirm-modal-action--fit"
        (click)="selectSecondary()"
      >
        {{ secondaryButton }}
      </button>
    }
    <button
      mat-flat-button
      type="button"
      color="{{ confirmButtonClass }}"
      id="confirm-primary"
      class="confirm-modal-action"
      [class.confirm-modal-action--full]="!secondaryButton"
      [class.confirm-modal-action--fit]="!!secondaryButton"
      (click)="confirm()"
    >
      <span>{{ confirmButton }}</span>
    </button>
  </mat-dialog-actions>
</form>
